module.exports = __webpack_public_path__ + "img/dgo-banner.eecaf538.jpg";